var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-layout',[_c('template',{slot:"drawers"},[_vm._t("drawers")],2),_c('template',{slot:"content"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"2"}},[_c('admin-menu')],1),_c('v-col',{attrs:{"cols":"10"}},[_vm._t("content")],2)],1)],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }